import { memo } from "react";

import type { HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { Description } from "./description";
import { TodoListContent } from "./todo-list";

type Props = {
	startGuide: HotelTopQuery["startGuide"];
	hotelTemplateSettings: HotelTopQuery["hotelTemplateSettings"];
	hotelUrls: HotelTopQuery["hotelUrls"];
	hotelID: string;
	isTestReservationAvailable: boolean;
};

export const TodoList = memo(
	({ startGuide, hotelTemplateSettings, hotelUrls, hotelID, isTestReservationAvailable }: Props) => {
		return (
			<div className="space-y-8">
				<Description />
				<TodoListContent
					startGuide={startGuide}
					hotelTemplateSettings={hotelTemplateSettings}
					hotelUrls={hotelUrls}
					hotelID={hotelID}
					isTestReservationAvailable={isTestReservationAvailable}
				/>
			</div>
		);
	},
);

TodoList.displayName = "TodoList";
